import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class ComponentSecurity {
  constructor(
    public id: number,
    public componentName: string,
    public user: string,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root"
})
export class ComponentSecurityAdapter implements Adapter<ComponentSecurity> {
  adapt(item: any): ComponentSecurity {
    return new ComponentSecurity(
      item.CPROWID,
      item.CPCOMPONENTNAME,
      item.CPUSER,
      item.CPCHANGEID,
      item.CPLASTUPDATED
    );
  }
}
